
/**
 * Interface for website analysis results
 */
export interface WebsiteAnalysisResult {
  businessName?: string;
  industry?: string;
  description?: string;
  targetAudience?: string;
  primaryServices?: string;
  companySize?: string;
  brandVoice?: string;
  tone?: string;
  formality?: string;
  keywords?: string[];
  colors?: string[];
  socialMedia?: Record<string, string>;
  keyMessages?: string[];
}

/**
 * Configuration options for AI requests
 */
export interface AIRequestOptions {
  systemPrompt: string;
  userPrompt: string;
  model?: string;
  temperature?: number;
  maxTokens?: number;
}

/**
 * Error types for website analysis
 */
export enum AnalysisErrorType {
  FETCH_ERROR = 'fetch_error',
  AI_ANALYSIS_ERROR = 'ai_analysis_error',
  EDGE_FUNCTION_ERROR = 'edge_function_error',
  PARSE_ERROR = 'parse_error',
  UNKNOWN_ERROR = 'unknown_error'
}
